import { render, staticRenderFns } from "./setPicture.vue?vue&type=template&id=69ca0494&scoped=true"
import script from "./setPicture.vue?vue&type=script&lang=js"
export * from "./setPicture.vue?vue&type=script&lang=js"
import style0 from "./setPicture.vue?vue&type=style&index=0&id=69ca0494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca0494",
  null
  
)

export default component.exports